export default "__VITE_ASSET__CXoEncrw__"